import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const haloSecurity = defineConnector({
  identifier: "haloSecurity",
  name: "Halo Security",
  tagLine: "External attack surface management",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(baseUrl || "https://api.halosecurity.com/api/v1"),
  auth: headerAuth([
    { name: "x-apikey", value: { from: "secret", field: "apiKey" } },
  ]),
  steps: [
    {
      title: "Set up Halo Security",
      items: [
        {
          kind: "markdown",
          content:
            "Create an API key under **Account → API** in Halo Security and enter it below. See [API authentication](https://docs.halosecurity.com/api/authentication).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "baseUrl",
          label: "API base URL",
          required: true,
          defaultValue: "https://api.halosecurity.com/api/v1",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText:
            "Use Halo Security’s documented global API URL. Manage API keys from the Account/API page in the Halo Security application.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: {
            kind: "secrets",
            field: "apiKey",
          },
          helperText:
            "Create an API key from Halo Security’s Account/API page and store it securely. The key is sent in the x-apikey request header.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://api.halosecurity.com/api/v1")
          .trim()
          .replace(/\/+$/, "") + "/user/me.json",
      ...{ method: "GET" },
    }),
  },
});
